<template>
  <el-dialog class="customDialog addSppucLayer" title="新建融合通信图层" :visible.sync="isShow" :close-on-click-modal="false" :close-on-press-escape = 'false' @close="onClose">
    <div class="formContainer">
      <el-form :model="formInline" :rules="rules" ref="form">
        <el-form-item label="设备类型：" prop="deviceType" class="row">
          <el-select class="form-short" v-model="formInline.deviceType" placeholder="请选择" :popper-append-to-body="false">
            <el-option
              v-for="item in SPPUCDeviceTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图层名称：" prop="name" class="row">
          <el-input class="form-short" v-model.trim="formInline.name" placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属文件夹：" class="row">
          <!-- <el-select class="form-short" v-model="formInline.folderId" filterable disabled placeholder="请选择">
            <el-option v-for="item in folderOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <TreeSelect class="form-short" v-model="formInline.folderId" filterable clearable :options="folderTree" :props="folderProps" placeholder="请选择"></TreeSelect>
        </el-form-item>
        <el-form-item label="关联融合通信源：" prop="isSppucData" >
          <el-switch
            v-model="formInline.isSppucData"
            active-color="#00A4F0"
            inactive-color="rgba(255, 255, 255, 0.2)"
            @change="formInline.tableId = undefined"
          >
          </el-switch>
        </el-form-item>
        <div v-if="formInline.isSppucData===false">
          <el-divider></el-divider>
          <!-- <p class="legend">
            <span>上传文件</span><span class="tip"> （文件大小不超过10M）</span>
          </p> -->
          <el-form-item label="导入数据：" prop="nameLabel">
            <div class="form-long">
              <div class="flex">
                <el-upload class="upload-demo" :limit="1" action="" ref="excelUpload" :show-file-list="true" :file-list="fileList" :auto-upload="false" :http-request="customUpload"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" :on-change="fileChange" :on-remove="fileListRemove" >
                  <div class="fileHandler" id="excelId">
                    <!-- <span class="title">导入数据</span><span class="tip"> （文件大小不超过10M）</span> -->
                    <div class="submitBtn">
                      <img src="@/assets/images/upload.png" />
                      <span>上传EXCEL文件</span>
                    </div>
                  </div>
                </el-upload>
                <!-- <span class="downLoad">
                  <i class="el-icon-download"></i>
                  <a :href="baseurl + 'map/data/download/template'" download>数据模板下载</a>
                </span> -->
              </div>
            </div>
          </el-form-item>
          <div class="tips">
            <span class="downLoad">
              <i class="el-icon-download"></i>
              <a :href="baseurl + 'map/data/download/template'" download>数据模板下载</a>
            </span>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addLayer } from '@/api/marker'
import { mapGetters } from 'vuex'
import TreeSelect from '@/components/TreeSelect/TreeSelect'
import { SPPUCDeviceTypeList, SPPUCDeviceType } from './SppucManager'
export default {
  name: 'AddLayer',
  components: {
    TreeSelect
  },
  computed: {
    ...mapGetters(['folderTree'])
  },
  data () {
    return {
      baseurl: process.env.VUE_APP_API_BASE_URL,
      isShow: false,
      formInline: {
        layerType: 'POINT',
        deviceType: SPPUCDeviceType.SPPUCDevice_Jly6,
        name: '',
        folderId: undefined,
        tableId: undefined,
        isSppucData: true,
        dataSourceType: 'EXCEL'
      },
      markerTypeOptions: [
        { id: 'POINT', title: '点' },
        { id: 'LINE', title: '线' },
        { id: 'PLANE', title: '面' }
      ],
      SPPUCDeviceTypeList,
      rules: {
        layerType: [
          { required: true, message: '请选择图层类型', trigger: 'blur' }
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入图层名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        dataSourceType: [
          { required: true, message: '请选择数据源类型', trigger: 'blur' }
        ],
        tableId: [
          { required: true, message: '请选择数据源', trigger: 'blur' }
        ]
        // folderId: [
        //   { required: true, message: '请选择所属文件夹', trigger: 'blur' }
        // ]
      },
      dataSourceType: [
        { value: 'EXCEL', name: 'EXCEL文件' },
        { value: 'API', name: 'API接口' }
      ],
      folderProps: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      file: '',
      fileList: [],
      // 表单列表
      tableList: [],
      loading: false
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.clear()
      this.isShow = true
    },
    clear () {
      this.formInline = this.$options.data().formInline
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    onClose () {
      // this.clear()
      this.isShow = false
    },
    // 图层类型改变
    onChangeLayerType (type) {
      if (type === 'POINT') {
        this.dataSourceType = [
          { value: 'EXCEL', name: 'EXCEL文件' },
          { value: 'API', name: 'API接口' }
        ]
      } else {
        this.dataSourceType = [
          { value: 'EXCEL', name: 'EXCEL文件' }
        ]
      }
      this.formInline.dataSourceType = 'EXCEL'
      this.formInline.tableId = undefined
    },
    // 创建未绑定数据图层
    async createLayer () {
      try {
        this.loading = true
        const res = await addLayer({
          name: this.formInline.name,
          mapId: this.$route.query.mapId ? this.$route.query.mapId : 0,
          type: 'POINT',
          groupId: this.formInline.folderId,
          module: 'sppuc',
          extendConfig: {
            deviceType: this.formInline.deviceType,
            isSppucData: this.formInline.isSppucData
          }
        })
        if (res.code === 200) {
          this.$Message('success', '创建图层成功')
          this.$emit('refresh')
          this.onClose()
          if (this.fileList.length > 0) {
            const curLayerId = res.data
            this.$emit('showImportMarker', {
              layerId: curLayerId,
              file: this.file
            })
          }
        }
      } finally {
        this.loading = false
      }
    },
    async onSubmit () {
      await this.$refs.form.validate()
      this.createLayer()
    },
    fileChange (file, fileList) {
      const types = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]
      const isExcel = types.includes(file.raw.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('仅能上传 excel 文件!')
        this.$refs.excelUpload.clearFiles()
      } else if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        this.$refs.excelUpload.clearFiles()
      } else {
        this.openFile = true
        document.getElementById('excelId').style.opacity = 0.6
        // if (this.ruleForm.dataSourceName.trim() === '') {
        //   this.ruleForm.dataSourceName =
        //     file.name.split('.')[0].length > 20
        //       ? file.name.split('.')[0].slice(0, 20)
        //       : file.name.split('.')[0]
        // }
        file.status = 'success'
        this.file = file.raw
        this.fileList = fileList
        this.$refs.form.validate()
      }
    },
    fileListRemove (file, fileList) {
      // this.$refs.form.clearValidate()
      this.file = ''
      this.fileList = []
      // const fileName =
      //   file.name.split('.')[0].length > 20
      //     ? file.name.split('.')[0].slice(0, 20)
      //     : file.name.split('.')[0]
      // if (this.ruleForm.dataSourceName === fileName) {
      //   this.ruleForm.dataSourceName = ''
      // }
      this.openFile = false
      document.getElementById('excelId').style.opacity = 1
    },
    // 文件自定义上传
    customUpload (file = this.file) {

    }
  }
}
</script>

<style lang="scss">
.addSppucLayer {
  .el-dialog{
    width: 460px;
    .el-form-item__content {
      width: unset !important;
    }
    .el-form-item__label{
      width: 140px;
    }
    .el-form-item__error{
      left: 120px;
    }
  }
  .el-divider{
    background-color: rgba(#FFFFFF, 0.1) !important;
    margin-top: 0px;
  }
  .el-dialog__body{
    .el-form-item__label{
      padding-right: 0
    }
  }
  .upload-demo {
    .fileHandler {
      .submitBtn {
        width: 164px;
        height: 32px;
        padding: 0 15px;
        background: rgba(0, 164, 240, 0.1);
        border: 1px dashed #00a4f0;
        border-radius: 6px;
        cursor: pointer;
        color: #00a4f0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 22px;
        }
      }
    }
    .placeholder {
      width: 318px;
      height: 50px;
      position: absolute;
      left: 0;
      top: 6px;
      cursor: not-allowed;
    }
    .el-upload-list__item {
      background: rgba(0, 0, 0, 0.3);
      .el-upload-list__item-name {
        color: #fff;
      }
    }
    .el-upload-list__item:hover {
      background: rgba(0, 0, 0, 0.4);
    }
    .el-upload-list{
      max-width: 165px;
    }
  }
}
</style>
<style lang="scss" scoped>
.addSppucLayer {
  .form-short {
    width: 260px !important;
  }
  .form-long{
    width: 450px;
  }
  .flex{
    display: flex;
  }
  .tips {
    text-align: right;
  }
  .downLoad {
    font-size: 14px;
    cursor: pointer;
    font-weight: 400;
    color: #00a4f0;
    a {
      text-decoration: none !important;
      color: #00a4f0;
    }
  }
}
</style>
